<template>
  <div id="collect-wrap">
    <div class="container" v-show="!pageNotShow">
      <div class="header">
        <p>发起寻车</p>
      </div>
      <div class="main">
        <div class="item item-1">
          <div>
            <input type="text" readonly @click="carBrandBoxShow" v-model="carBrandVal">
            <p>品牌</p>
            <img src="../assets/image/Vcar_Collect/select_img.png" v-if="carBrandCode == null">
          </div>
        </div>
        <div class="item item-1">
          <div>
            <input type="text"  @click="getCarSeries" v-model="carSeriesVal" readonly>
            <p>车系</p>
            <img src="../assets/image/Vcar_Collect/select_img.png" v-if="carSeriesCode == null">
          </div>
        </div>
        <div class="item item-1">
          <div>
            <input type="text" @click="getCarModel" v-model="carModelVal" readonly>
            <p>车型</p>
            <img src="../assets/image/Vcar_Collect/select_img.png" v-if="carModelCode == null">
          </div>
        </div>
        <div class="item item-2">
          <div>
            <input type="text" maxlength="20" v-model="color">
            <p>颜色</p>
          </div>
        </div>
        <div class="item item-1">
          <div>
            <input type="text" v-model="addressProvince" @click="provinceBoxShow" readonly>
            <p>省份</p>
            <img src="../assets/image/Vcar_Collect/select_img.png" v-show="addressProvinceCode == null">
          </div>
        </div>
        <div class="item item-1">
          <div>
            <input type="text" @click="getCity" v-model="addressCity" readonly>
            <p>城市</p>
            <img src="../assets/image/Vcar_Collect/select_img.png" v-show="addressCityCode == null">
          </div>
        </div>
        <div class="item item-3">
          <!-- 1 否 2 是-->
          <div>
            <div @click="selfByCar">
              <img :src="isSelfFlag == 1  ? vcyes : vcno">
              <p>否</p>
            </div>
            <div @click="selfByCar">
              <img :src="isSelfFlag == 0  ? vcyes : vcno">
              <p>是</p>
            </div>
            <p>本人购车</p>
          </div>
        </div>
        <div class="comment">
          <p>需求备注</p>
          <div contenteditable @input="getComment"></div>
        </div>
      </div>
      <div class="footer">
        <button @click="submitData">提交</button>
      </div>
    </div>
    <!-- 省份弹窗 -->
    <div v-show="provinceBoxShowFalg" class="eventBox" id="provinceBox">
      <div class="box_part" id="box_part">
        <div class="initial_index_part">
          <ul>
            <li v-for="item in initialsList" @click="quickPositioning('#p_'+ item)">{{item}}</li>
          </ul>
        </div>
        <div class="address_section" v-for="value in initialsList">
          <div class="address_part">
            <div class="caption" :id="'p_' + value"><p>{{value}}</p></div>
            <div class="address_cell" v-for="item in provincesList" v-if="item.backupCol1 == value"
                 @click="getSelecteProviceInfo(item.itemCd, item.itemContent)">{{item.itemContent}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 城市弹窗 -->
    <div v-show="cityBoxShowFalg" class="eventBox" id="cityBox">
      <div class="box_part">
        <div class="address_section">
          <div class="address_part">
            <div class="address_cell" v-for="(value,key) in cityList" @click="cityBoxShow(value, key)">{{value}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 品牌弹窗 -->
    <div v-show="carBrandBoxShowFlag" class="eventBox" id="carBrandBox">
      <div class="box_part">
        <div class="initial_index_part">
          <ul>
            <li v-for="item in initialsCarList" @click="quickPositioning('#c_' + item)">{{item}}</li>
          </ul>
        </div>
        <div class="address_section" v-for="value in initialsCarList">
          <div class="address_part">
            <div class="caption" :id="'c_' + value"><p>{{value}}</p></div>
            <div class="address_cell" v-for="item in carBrandList" v-if="item.initial == value"
                 @click="getSelectedCarBrand(item.value, item.name)">{{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 车系弹窗 -->
    <div v-show="carSeriesBoxShowFlag" class="eventBox" id="carSeriesBox">
      <div class="search" v-if="carsSeriesSearchFlag">
        <input placeholder="输入车系" v-model="csFilter"></input>
      </div>
      <div class="box_part" :class="carsSeriesSearchFlag?'box_part2':''">
        <div class="address_section">
          <div class="address_part">
            <div class="address_cell" v-for="item in carSeriesFilterList" @click="getSelectedCarSeries(item.name, item.value)">{{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 车型弹窗 -->
    <div v-show="carModelBoxShowFlag" class="eventBox" id="carModelBox">
      <div class="search" v-if="carModelSearchFlag">
        <input placeholder="输入车型" v-model="cmFilter"></input>
      </div>
      <div class="box_part" :class="carModelSearchFlag?'box_part2':''">
        <div class="address_section">
          <div class="address_part">
            <div class="address_cell" v-for="item in carModelFilterList" @click="getSelectedCarModel(item.name, item.value, item.price)">{{item.name}}<span>{{item.price}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Indicator} from 'mint-ui'
  import qs from 'qs'
  import common from '../utils/common'
  import vcno from '../assets/image/Vcar_Collect/icon-no.png'
  import vcyes from '../assets/image/Vcar_Collect/icon-yes.png'
  import constants from "../utils/constants";
  import axios from 'axios'

  export default {
    name: "Vcar_Collect",
    data() {
      return {
        pageNotShow: false, // 弹窗弹出时控制页面滚动

        comment: null, // 备注
        carBrandList: null,
        initialsCarList: [], //首字母集合
        carBrandBoxShowFlag: false, // 车品牌信息
        carBrandVal: null, // 选中的车品牌名称
        carBrandCode: null, // 选中的车品牌Code

        carSeriesBoxShowFlag: false,
        carSeriesList: null, // 车系信息
        carSeriesFilterList: null, // 车系筛选后信息
        carsSeriesSearchFlag: false,
        carSeriesVal: null, // 选中的车品牌名称
        carSeriesCode: null, // 选中的车品牌Code
        csFilter: null, // 车系检索条件

        carModelBoxShowFlag: false,
        carModelList: null,
        carModelFilterList: null,
        carModelSearchFlag: false,
        carModelVal: null,
        carModelCode: null,
        cmFilter: null, //车型检索条件
        carPrice: null,
        color: null,

        provincesList: NaN, // 省份
        provinceBoxShowFalg: false, // 省份弹窗显隐
        initialsList: [], // 省份首字母
        cityBoxShowFalg: false, // 城市弹窗的显示隐藏
        cityList: [],  //城市er
        addressProvince: null,  //选中的省份
        addressProvinceCode: null, // 选中省份的Code
        addressCity: null, // 选中城市值
        addressCityCode: null, // 选中城市Code

        isSelfFlag: 1,
        vcyes: vcyes,
        vcno: vcno
      }
    },
    watch: {
      csFilter(curVal, oldVal) {
        // 实现input连续输入，只发一次请求
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.handleChangeCsFilter(curVal)
        }, 500)
      },
      cmFilter(curVal, oldVal) {
        // 实现input连续输入，只发一次请求
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.handleChangeCmFilter(curVal)
        }, 500)
      }
    },
    mounted() {
      if(common.isEmpty(sessionStorage.getItem("mobile"))){
        common.redirect(this, 'vcar_login')
      }
      window.scrollTo(0, 0)
      const that = this
      that.$nextTick(function () {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        // 获取省份信息
        that.$axios.get('/marketing/getprovince', {}).then(function (res) {
          Indicator.close()
          that.provincesList = res.data.data.proMap
          for (let key in that.provincesList) {
            if (that.initialsList.indexOf(that.provincesList[key].backupCol1) == -1) {
              that.initialsList.push(that.provincesList[key].backupCol1)
            }
          }
          that.initialsList.sort()
        }).catch(function (error) {
          Indicator.close()
          common.tipToast(error.data.msg)
          return
        })

        // 品牌信息
        that.$axios.post('/marketing/vhvm/carbrand', {}).then(function (res) {
          Indicator.close()
          if (res.data.code == 0) {
            that.carBrandList = res.data.data
            for (let key in that.carBrandList) {
              if (that.initialsCarList.indexOf(that.carBrandList[key].initial) == -1) {
                that.initialsCarList.push(that.carBrandList[key].initial)
              }
            }
          }
        }).catch(function (error) {
          Indicator.close()
          common.tipToast(error.data.msg)
          return
        })

        common.wxShare(that, constants.VC_SHAREINFO)
      })
    },
    methods: {
      handleChangeCsFilter (val) {
        this.csFilter = common.trimAll(val)
        if(common.isEmpty(this.csFilter)) {
          this.carSeriesFilterList = this.carSeriesList
        }else{
          let arr = this.carSeriesList.filter((value) => {
          return value.name.indexOf(this.csFilter.toUpperCase()) > -1 || value.name.indexOf(this.csFilter.toLowerCase()) > -1
          })
          this.carSeriesFilterList = arr
        }
        window.scrollTo(0, 0)
      },

      handleChangeCmFilter(val) {
        this.cmFilter = common.trimAll(val)
        if(common.isEmpty(this.cmFilter)) {
          this.carModelFilterList = this.carModelList
        }else{
          let arr = this.carModelList.filter((value) => {
          return value.name.indexOf(this.cmFilter.toUpperCase()) > -1 ||
            value.name.indexOf(this.cmFilter.toLowerCase()) > -1 ||
            value.price.toString().indexOf(this.cmFilter) > -1
          })
          this.carModelFilterList = arr
        }
        window.scrollTo(0, 0)
      },

      /* 弹出弹窗后页面禁止滚动 */
      pageScroll() {
        this.pageNotShow = !this.pageNotShow
      },

      /* 获取备注填写内容 */
      getComment(e) {
        this.comment = e.target.innerText
      },

      /* 省份快速定位 */
      quickPositioning(id){
        let anchor = this.$el.querySelector(id)
        window.scrollTo(0, anchor.offsetTop)
      },

      /* 品牌弹窗显隐 */
      carBrandBoxShow() {
        this.carBrandBoxShowFlag = !this.carBrandBoxShowFlag
        // 弹窗显示 页面不显示
        if(this.carBrandBoxShowFlag) {
          this.pageNotShow = true
        }else{
          this.pageNotShow = false
        }
        window.scrollTo(0, 0)
      },
      /* 车品牌选中页面设值，隐藏弹窗 */
      getSelectedCarBrand(code, val) {
        this.carBrandVal = val,
        this.carBrandCode = code,
        this.carSeriesVal = null,
        this.carSeriesCode = null,
        this.carModelVal = null
        this.carModelCode = null
        this.carPrice = null

        this.carBrandBoxShow()
      },

      getSelectedCarSeries(val ,code) {
        this.carSeriesVal = val,
        this.carSeriesCode = code,
        this.carModelVal = null
        this.carModelCode = null
        this.carPrice = null
        this.carSeriesBoxShow()
      },

      /* 车系弹窗显隐 */
      carSeriesBoxShow() {
        this.carSeriesFilterList = this.carSeriesList
        this.carSeriesBoxShowFlag = !this.carSeriesBoxShowFlag
        // 弹窗显示 页面不显示
        if(this.carSeriesBoxShowFlag) {
          this.pageNotShow = true
        }else{
          this.pageNotShow = false
          this.csFilter = null
        }
        window.scrollTo(0, 0)
      },

      getCarSeries() {
        const that = this
        if(that.carBrandCode == null) {
          common.tipToast('请先选择车品牌')
          return
        }
        let data = {"carBrand": that.carBrandCode}
        that.$axios.post('/marketing/vhvm/carseries', qs.stringify(data)).then(function (res) {
          Indicator.close()
          if (res.data.code == 0) {
            if(res.data.data == null || res.data.data.length == 0){
              common.tipToast('对应车系为空')
              return
            }
            that.carSeriesList = res.data.data
            if(that.carSeriesList.length > 8) {
              that.carsSeriesSearchFlag = true
            }else{
              that.carsSeriesSearchFlag = false
            }
            that.carSeriesBoxShow()
          }
        }).catch(function (error) {
          Indicator.close()
          common.tipToast(error.data.msg)
          return
        })

      },

      /* 车型弹窗显隐 */
      carModelBoxShow() {
        this.carModelFilterList = this.carModelList
        this.carModelBoxShowFlag = !this.carModelBoxShowFlag
        // 弹窗显示 页面不显示
        if(this.carModelBoxShowFlag) {
          this.pageNotShow = true
        }else{
          this.pageNotShow = false
          this.cmFilter = null
        }
        window.scrollTo(0, 0)

      },

      getCarModel() {
        const that = this
        if(that.carSeriesCode == null) {
          common.tipToast('请先选择车系')
          return
        }
        let data = {"carSeries": that.carSeriesCode}
        that.$axios.post('/marketing/vhvm/carmodel', qs.stringify(data)).then(function (res) {
          Indicator.close()
          if (res.data.code == 0) {
            if(res.data.data!= null && res.data.data.length > 0){
              that.carModelList = res.data.data
              for (let key in that.carModelList) {
                that.carModelList[key].name = common.trimAll(that.carModelList[key].name)
              }
              if(that.carModelList.length > 8) {
                that.carModelSearchFlag = true
              }else{
                that.carModelSearchFlag = false
              }
              that.carModelBoxShow()
            }else{
              common.tipToast('对应车型为空')
              return
            }
          }
        }).catch(function (error) {
          Indicator.close()
          common.tipToast(error.data.msg)
          return
        })
      },

      getSelectedCarModel(val, code, price){
        const that = this
        that.carModelVal = val
        that.carModelCode = code
        that.carPrice = price
        that.carModelBoxShow()
      },


      /* 省份弹窗显示隐 */
      provinceBoxShow() {
        this.provinceBoxShowFalg = !this.provinceBoxShowFalg
        // 弹窗显示 页面不显示
        if(this.provinceBoxShowFalg) {
          this.pageNotShow = true
        }else{
          this.pageNotShow = false
        }
        window.scrollTo(0, 0)
      },

      /* 省份选中页面设值，隐藏省份弹窗 */
      getSelecteProviceInfo(code, val) {
        this.addressProvince = val
        this.addressProvinceCode = code
        this.addressCityCode = null
        this.addressCity = null
        this.provinceBoxShow()
      },

      /* 城市弹窗隐藏，并对页面城市弹窗设值 */
      cityBoxShow(value, key) {
        this.cityBoxShowFalg = !this.cityBoxShowFalg
        // 弹窗显示 页面不显示
        if(this.cityBoxShowFalg) {
          this.pageNotShow = true
        }else{
          this.pageNotShow = false
        }
        window.scrollTo(0, 0)
        this.addressCity = value
        this.addressCityCode = key
      },

      /* 获取城市弹窗 */
      getCity() {
        const that = this
        if (that.addressProvinceCode == null) {
          common.tipToast('请先选择省份')
          return
        }
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        let data = {"num": '0', "strnum": that.addressProvinceCode}
        that.$axios.post('/marketing/getCity', qs.stringify(data)).then(function (res) {
          that.cityList = res.data.data
          that.cityBoxShow()
          Indicator.close();
        }).catch(function (error) {
          Indicator.close();
          common.tipToast(error.data.msg)
          return
        })
      },

      /* 本人购车是否 */
      selfByCar() {
        if(this.isSelfFlag == 1) {
          this.isSelfFlag = 0
        }else{
          this.isSelfFlag = 1
        }
      },

      /* 提交信息*/
      submitData() {
        const that = this
        if (common.isEmpty(that.carBrandCode)) {
          common.tipToast('请选择车辆品牌')
          return
        }
        if (common.isEmpty(that.carSeriesCode)) {
          common.tipToast('请选择车系')
          return
        }
        if (common.isEmpty(that.carModelCode)) {
          common.tipToast('请选择车型')
          return
        }

        if(common.isEmpty(that.color)) {
          common.tipToast('请填写车辆颜色')
          return
        }

        if(common.isEmpty(that.addressProvinceCode)) {
          common.tipToast('请选择省份')
          return
        }

        if(common.isEmpty(that.addressCityCode)) {
          common.tipToast('请选择城市')
          return
        }

        let vhVmCstm = {
          reqBrandC: that.carBrandVal,
          reqVehSeriesC: that.carSeriesVal,
          reqVehTypeC: that.carModelVal,
          reqVehXcolorC: that.color,
          reqProvinceC: that.addressProvince,
          reqVehCityC: that.addressCity,
          reqVehMsrpC: that.carPrice,
          reqVehNoteC: that.comment,
          reqRequestormobileC: sessionStorage.getItem("mobile"),
          reqRequestorC: sessionStorage.getItem("customerName"),
          reqVmPurposeC: that.isSelfFlag
        }
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        axios.defaults.headers.post['Authorization'] = 'Bearer ' + sessionStorage.getItem("access_token")
        that.$axios({
          method: 'post',
          url: '/marketing/vhvm/create',
          data: vhVmCstm,
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function (res) {
          Indicator.close();
          if(res.data.code == 0) {
            common.isEmpty('信息提交成功')
            setTimeout(() => {
              common.redirect(that, 'vcar_list'), 3000
            })
          }
        }).catch(function (error) {
          Indicator.close();
          common.tipToast(error.data.msg)
          return
        })
      }
    }
  }
</script>

<style scoped>
  p,div,sup,li, input {
    font-family: "PingFang SC";
  }

  #collect-wrap {
    width: 100vw;
    background-color: #fff;
  }

  #collect-wrap > .container {
    margin: 0 auto;
    width: 7.5rem;
  }

  .container > .header {
    margin: 0 auto;
    margin-top: 0.26rem;
    width: 6.4rem;
    height: 0.65rem;
  }

  .container > .header > p {
    margin: 0;
    font-size: 0.46rem;
    font-weight: bold;
    line-height: 0.65rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .container > .main {
    padding-top: 0.585rem;
    width: 7.5rem;
  }

  .container > .main > .item {
    width: 100%;
    border-bottom: 0.01rem solid #F0F0F0;
  }

  .container > .main > .item > div {
    position: relative;
    margin: 0 auto;
    width: 6.4rem;
    height: 0.98rem;
    font-size: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .container > .main > .item-3 > div {
    justify-content: flex-end;
  }

  .container > .main > .item-3 > div > div {
    height: 100%;
    font-size: 0.32rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .container > .main > .item-3 > div > div {
    margin-left: 1rem;
    justify-content: flex-end;
  }
  .container > .main > .item-3 > div > div > img {
    margin-right: 0.21rem;
    width: 0.36rem;
    height: 0.36rem;
  }

  .container > .main > .item > div > p {
    position: absolute;
    height: 0.98rem;
    top: 0;
    left: 0;
    font-size: 0.32rem;
    color: #000000;
    line-height: 0.98rem;
    letter-spacing: -0px;
    z-index: 1;
  }

  .container > .main > .item > div > img {
    /*border: 1px solid black;*/
    position: absolute;
    top: 0.4rem;
    right: 0;
    width: 0.18rem;
    height: 0.18rem;
    z-index: 1;
  }

  .container > .main > .item > div > input {
    margin: 0;
    padding: 0;
    padding-left: 1.5rem;
    width: 100%;
    height: 0.94rem;
    line-height: 0.40rem;
    font-size: 0.30rem;
    border-width: 0;
    outline: 0;
    text-align: right;
    /*border: 0.01rem solid blue;*/
  }

  .container > .main > .comment {
    margin: 0 auto;
    width: 6.86rem;
  }

  .container > .main > .comment > p {
    margin: 0 auto;
    padding-top: 0.23rem;
    padding-bottom: 0.33rem;
    width: 6.4rem;
    font-size: 0.32rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .container > .main > .comment > div {
    margin: 0 auto;
    padding: 0.15rem 0.08rem;
    width: 6.7rem;
    min-height: 2.08rem;
    font-size: 0.28rem;
    color: #000000;
    background: #FFFFFF;
    box-shadow: 9px 12px 14px -7px rgba(0, 0, 0, 0.11);
    outline: none;
    text-indent: 2em;
  }

  .container > .footer {
    margin-top: 1.21rem;
    margin-bottom: 1.65rem;
    width: 100%;
    text-align: center;
  }

  .container > .footer > button {
    margin: 0 auto;
    padding: 0;
    width: 5.80rem;
    height: 1rem;
    display: block;
    background-image: linear-gradient(90deg, #195EDB 0%, #2594FE 100%);
    border-radius: 0.5rem;
    border-width: 0;
    outline: none;
    font-size: 0.32rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }

  .eventBox {
    margin: 0 auto;
    position: relative!important;
    width: 7.5rem;
    background-color: #fff;
  }
  .eventBox > .search {
    margin: 0 auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 7.5rem;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    box-shadow: 0 2px 6px 6px #eee;
    z-index: 12;
  }
  .eventBox > .search > input {
    padding: 0 0.15rem;
    width: 86%;
    height: 0.8rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    border-radius: 0.40rem;
    border-width: 0;
    outline: 0;
    background-color: #F7F7F7;
    display: flex;
    align-items: center;
    text-align: center;
    display: block;
  }
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #999;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #999;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #999;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #999;
  }
  .box_part {
    position: relative;
    width: 100%;
    overflow: auto;
  }

  .box_part2 .address_cell:first-child {
    margin-top: 1.2rem;
  }

  .box_part p {
    margin: 0;
    padding: 0;
  }

  .address_part > .caption {
    padding: 0.1rem 0.25rem;
    font-size: 0.36rem;
    color: #fff;
    background-color: #999 !important;
  }

  .address_part > .caption > p {
    background-color: #999 !important;
  }

  .address_part > .address_cell {
    border-bottom: 0.04rem solid #f4f4f4;
    padding: 0.25rem;
    font-size: 0.30rem;
  }
  .address_part > .address_cell > span {
    margin-left: 0.1rem;
    font-size: 0.30rem;
    color: #FF4A26;
  }



  /* 字母导航*/
  .initial_index_part {
    /*border: 1px solid black;*/
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    display: flex;
    align-items: center;
    z-index: 11;
  }
  .initial_index_part > ul{
    padding: 0;
    margin: 0;
    height: 80%;
    list-style: none;
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: space-evenly;
  }
  .initial_index_part > ul > li{
    width: 0.6rem;
    height: 0.5rem;
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/Vcar_Collect.vue